module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h12"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('img', {
    attrs: {
      "alt": "img6.png",
      "src": "Images/img6.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("HILE")]), _vm._v(" writing a book is usually a solitary venture, getting one published is not. I’d like to thank everyone who helped that happen.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("A huge thank you to Elizabeth at Dreamspinner Press for taking a chance on me and publishing my first book, which is the prequel to this one. To Lynn and her team of editors for polishing my baby for publishing and going over the manuscript for both grammar and continuity. Any mistakes made are mine and not theirs. To Anne Cain for her wonderful cover art that brought Keno and Aboshi to life for lots of people.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Big thank yous to Mark, Ed, and Tim for the long walks around Castle Island and letting me bounce ideas off them and arguing with me about plots and logic and listening to me babble about my research. A huge additional thank you to Ed for his lifesaving effort of looking over and editing my manuscript as both a work in progress and as the final product before I submitted it to Dreamspinner Press. Thanks to my family for their support and their excitement that I was published.")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("And as always, I wouldn’t be where I am today without the support of the husband. Thank you, Russ.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0